export const PAGE_TITLE = 'Polonium';
export const CONTACT_EMAIL = 'contact@poloniumfoundation.org';
export const PARTNERS_EMAIL = 'partners@poloniumfoundation.org';
export const NETWORK_EMAIL = 'network@poloniumfoundation.org';
export const POLONIUM_FOUNDATION_WEBSITE = 'https://poloniumfoundation.org/';
export const EL_PASSION_WEBSITE = 'https://www.elpassion.com/';
export const POLONIUM_TWITTER = 'https://twitter.com/polonium_org';
export const POLONIUM_FACEBOOK = 'https://www.facebook.com/polonium.org/';
export const POLONIUM_LINKEDIN =
  'https://www.linkedin.com/company/polonium-foundation/?originalSubdomain=pl';
export const POLONIUM_YOUTUBE = 'https://www.youtube.com/channel/UCkinL18xdseF6OxAzkHhaBQ';
export const RESEARCH_WEBSITE = 'https://poloniumfoundation.org/research';

export const GOOGLE_ANALYTICS_EVENTS = {
  AUTH_LOGIN_SUBMIT: 'auth_login_submit',
  AUTH_LOGIN_SUCCESS: 'auth_login_success',
  AUTH_LOGIN_ERROR: 'auth_login_error',

  AUTH_REGISTER_SUBMIT: 'auth_register_submit',
  AUTH_REGISTER_SUCCESS: 'auth_register_success',
  AUTH_REGISTER_ERROR: 'auth_register_error',

  AUTH_PASSWORD_RESET: 'auth_password_reset',

  NEWSLETTER_SUBMIT: 'newsletter_submit',
  NEWSLETTER_SUCCESS: 'newsletter_success',

  COMMUNITY_SEARCH: 'community_search',
  COMMUNITY_CITY_CLICKED: 'community_city_clicked',
  COMMUNITY_VIEW_ALL_CLICKED: 'community_view_all_clicked',

  JOB_OFFER_VIEW: 'job_offer_view',
  JOB_OFFER_APPLY_CLICK: 'job_offer_apply_click',
  JOB_OFFER_APPLY_SUBMIT: 'job_offer_apply_submit',

  EVENT_PAGE_VIEW: 'event_page_view',
  GO_TO_EVENT: 'go_to_event_click',
  EVENTS_FILTER_APPLIED: 'events_filter_applied',
  EVENT_CREATE_PAGE_VIEW: 'event_create_page_view',
  EVENT_CREATED: 'event_created',

  GRANT_VIEW: 'grant_view',
  GRANT_APPLY_CLICK: 'grant_apply_click',

  ONBOARDING_STEP: 'onboarding_step',

  FORM_SUBMIT: 'form_submit',

  SEARCH_SUBMIT: 'search_submit',
  FILTER_SELECT: 'filter_select',

  FORUM_SELECT_CATEGORY: 'forum_select_category',
  FORUM_CREATE_POST: 'forum_create_post',
  FORUM_VOTE_POST: 'forum_vote_post',
  FORUM_SUBMIT_COMMENT: 'forum_submit_comment',
  FORUM_REPORT_POST: 'forum_report_post',

};
